import { actions } from "../../utils/constants"

const initialState = {
  leftTherapy: [],
  rightTherapy: [],
  VolumeLevel:{}
};
const leftReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.LEFT_THERAPY:
      return { ...state, leftTherapy: action.value };
    case actions.RIGHT_THERAPY:
      return { ...state, rightTherapy: action.value };
      case actions.VOLUME_LEVELS:
        return { ...state, VolumeLevel: action.value };
  
    default:
      return { ...state };
  }
};
export default leftReducer;
